import querystring from 'querystring'

export default function table(app)
{

    /**
     * Sort the results
     *
     * @return void
     */

    const sortResults = function(){

        // For storing the values
        const values = {}

        // Get the sorting filters
        const $sortingFilters = $('.sorting-filters:visible, .sort:visible')

        // Get the filters
        const $filters = $(':input', $sortingFilters)

        // For each filter
        $filters.each(function(){

            // Get the input
            const $input = $(this)

            // Get the value
            const value = $input.val()

            // Move on if no value
            if(!value || value.length === 0) return

            // Store the value
            values[$input.attr('name')] = value

        })

        // Sort the results
        window.location.href = $sortingFilters.data('action') + '?' + querystring.stringify(values)

    }

    const onDateChange = (event) => {

        // Get the element
        const $el = event.inst.$el

        // Stop if not complete selection
        if(event.date.length !== 2) return

        // Sort the results
        sortResults()

    }

    $(function(){

        const $sorting = $('form.sorting-filters, form.sort')

        if($sorting.length === 0) return

        $sorting.on('change', ':input', sortResults)
        app.events.on('kx_date_select', onDateChange)

    })

}
